//
//
//
//
//
//
//
//
//
//
//
//

import Axios from "axios";
import httpApi from "../../api/cashier";
import isLocal from "../../api/isLocal";
import Cookies from "../../api/cookies";
import { Toast } from "mint-ui";
export default {
  name: "author",
  data() {
    return {
      socialId: 2,
      data: {},
      isLocal: isLocal
    };
  },
  created() {},
  mounted() {
    let href = localStorage.getItem("localhref");
    console.log("让看看:", localStorage);
    if (href) {
      console.log("看看");
      //路由有缓存了
      let goodsDetail = {
        myapp_id: Number(href.split("myapp_id=")[1].split("&")[0]),
        subject: href.split("subject=")[1].split("&")[0],
        device_id: href.split("device_id=")[1].split("&")[0],
        device_sn: href.split("device_sn=")[1].split("&")[0]
      };
      console.log();
      localStorage.setItem("data", JSON.stringify(goodsDetail));
      Cookies.setCookie("user_data", localStorage.getItem("data"));
      this.data = { ...goodsDetail };
    }
    let user_data = Cookies.getCookie("user_data");
    if (user_data) {
      console.log("cookis", localStorage.getItem("data"));
      localStorage.setItem("data", user_data);
      this.data = JSON.parse(user_data);
    }
    console.log(user_data, 0);
    console.log(this.data, 1);
    console.log(localStorage.getItem("data"), 2);

    let ua = navigator.userAgent.toLowerCase();

    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      let code = this.$route.query.code;
      if (code) {
        this.getUser(code);
      } else {
        this.getAppid();
      }
    }

    // location.href = 'http://localhost:8080/guide?auth_code=67f55aec0ea240aa9ab96d67b42bYX12&tenantCode=S70581463';
  },
  methods: {
    getAppid() {
      let appid = JSON.parse(localStorage.getItem("data"));
      let config = {
        myapp_id: appid.myapp_id
      };
      httpApi.getAppid(config).then(res => {
        console.log(res.status )
        if (res.status == 200) {
          this.getWXCode(res.data.appid);
        } else {
          Toast({
            message: res.msg,
            iconClass: "icon icon-success",
            duration: 60000
          });
        }
      });
    },
    //微信获取code
    getWXCode(appid) {
      let url = encodeURIComponent(window.location.href);
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    },
    //微信获取openID
    getUser(code) {
      let that = this;
      let config = {
        myapp_id: this.data.myapp_id,
        code: code
      };

      httpApi.getOpenid(config).then(res => {
        if (res.status == 200) {
          localStorage.setItem("openid", res.data.openid);
          that.$router.push("/pay");
        } else {
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/author/index.vue